export default "__VITE_ASSET__BuUWaMpa__"